export default __webpack_public_path__ + "static/media/swap-price.0ebaf72a.svg";